import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function MLDiscountsIncludedFeatures({ data, title, show }) {

    if (_.isEmpty(data)) {
        return null;
    }

    if (show) {
        return (
            <div className="vertical-spacing-30">
                <hr className="vertical-spacing-30" />
                <h2 className="section-header vertical-spacing-20">
                    {title}
                </h2>
                {data.map((term, index) => {
                    if (index % 3 === 0) {
                        return (
                            <div className="row clearfix">
                                <div className="col-md-4 vertical-spacing-10">{data[index].name}</div>
                                {data[index+1] &&
                                    <div className="col-md-4 vertical-spacing-10">{data[index+1].name}</div>
                                }
                                {data[index+2] &&
                                    <div className="col-md-4 vertical-spacing-10">{data[index+2].name}</div>
                                }
                            </div>
                        );
                    }
                    return (<></>);
                })}
            </div>
        );
    }
    return ( <></> );
}

MLDiscountsIncludedFeatures.propTypes = {
    data: PropTypes.shape([]),
    title: PropTypes.string,
    show: PropTypes.bool
};
MLDiscountsIncludedFeatures.defaultProps = {
    data: [],
    title: "",
    show: false
};
export default MLDiscountsIncludedFeatures;
